export const GET_DROPDOWN_FAILED = "GET_DROPDOWN_FAILED";
export const GET_DROPDOWN_SUCCESS = "GET_DROPDOWN_SUCCESS";